// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"c53c6e4d","296":"2143a515","402":"d850d35b","437":"24a0f24b","472":"dccb0bea","714":"67c1d56b","777":"bc4a48f4","930":"cd41915c","934":"af0394f0","952":"8ec6bc57"}[chunkId] + ".chunk.js";
};